module.exports = __webpack_public_path__ + "img/BMC_ARIC_cover.b555457b.jpg";